module.exports = __webpack_public_path__ + "img/Jeremiah-Chiu---Zoom-Room-1-p-500.81d193d3.jpg";